export const PLATFORMS_NAMES_MAP = {
  shopify: 'controlpanel.global.shopify',
  prestashop: 'controlpanel.global.prestashop'
};
